<template lang="pug">
  div
    template(v-if="!cryptoaddressAvailable")
      div.alert.alert-warning
        i18n(path="notice1" tag="div")
          template(v-slot:link)
            a(href="/profile/update").link {{$t('Повышение статуса')}}
    template(v-if="cryptoaddressAvailable")
      slot
</template>

<script lang="ts">
import Vue from "vue";
import {Component, Prop} from "vue-property-decorator";

@Component({
  name: "ProfileUpdateRequiredCryptoNotice"
})
export default class ProfileUpdateRequiredCryptoNotice extends Vue {
  @Prop({default: false})
  cryptoaddressAvailable: boolean


}
</script>

<style scoped lang="less">
.alert.alert-warning {
  .link {
    text-decoration: underline;
    font-weight: bolder;
    color: #333;
  }

  border-radius: 4px;
  color: #555;
  //border-color: #71a719;
}

</style>

<i18n>
{
  "ru": {
    "notice1": "Для пополнения криптовалютных счетов BTC и ETH прямыми переводами необходимо пройти верификацию в разделе {link}. Пополнение USDT и USDC доступны уже сейчас."
  },
  "en": {
    "Повышение статуса": "Profile update",
    "notice1": "To top up BTC and ETH crypto accounts with direct transfers, you need to pass verification in the {link} section. USDT and USDC top-ups are available now."
  }
}
</i18n>
